if (!customElements.get('video-content')) {
  customElements.define('video-content', class VideoContent extends HTMLElement {
    constructor() {
      super();
      this.videos = this.querySelectorAll('video');
      if(!this.videos.length) return;
      this.button = this.querySelector('button');
      this.content = this.querySelector('.content')
      this.button.addEventListener('click', this.videoPlayer.bind(this));
      this.videos.forEach(video => video.addEventListener('ended', this.videoContent.bind(this)))
    }

    videoPlayer(event) {
      event.preventDefault()
      this.videos.forEach(video => {
        if (video.paused) {
          video.play();
          video.setAttribute("controls")
          this.content.style.display = 'none'
        } else {
          video.pause()
        }
      })
    }

    videoContent(event) {
      event.preventDefault();
      this.videos.forEach(video => {
        video.load();
        video.removeAttribute("controls");
      })
      this.content.style.display = ''
    }
  })
}